import React from 'react';
import { Divider, PageWrapper, Wrapper } from '@screentone/core';
import classnames from 'classnames';

import styles from './WidePageWrapper.module.scss';

type Slot = {
  children?: React.ReactNode;
  // eslint-disable-next-line react/no-unused-prop-types
  padding?: any;
};

export const WidePageWrapper = ({
  className,
  children,
  ...props
}: {
  className?: string;
  children: React.ReactNode;
  margin?: any;
  padding?: any;
}) => {
  let header: React.ReactNode = null;
  let wrapperLeft: React.ReactNode = null;
  let wrapperRight: React.ReactNode = null;

  let headerProps: Record<string, any> = {};
  let wrapperLeftProps: Record<string, any> = {};
  let wrapperRightProps: Record<string, any> = {};

  React.Children.forEach(children, (child) => {
    if (!React.isValidElement<Slot>(child)) {
      return;
    }

    if (child.type === WidePageWrapper.Header) {
      header = child.props.children;
      headerProps = child.props;
    }

    if (child.type === WidePageWrapper.Right) {
      wrapperRight = child.props.children;
      wrapperRightProps = child.props;
    }

    if (child.type === WidePageWrapper.Left) {
      wrapperLeft = child.props.children;
      wrapperLeftProps = child.props;
    }
  });

  // If no slots are provided, render children directly
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  const shouldDefaultChildren = !header || !wrapperLeft || !wrapperRight;

  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (shouldDefaultChildren) {
    return (
      <PageWrapper {...props} className={classnames(styles.widePageWrapper, className)}>
        {children}
      </PageWrapper>
    );
  }

  const sectionPadding = { top: 'mlg', right: 'md', bottom: 'sm' };

  return (
    <PageWrapper {...props} className={classnames(styles.widePageWrapper, className)}>
      <Wrapper {...headerProps} id="widepage-wrapper-header">
        {header}
      </Wrapper>
      <Divider className={styles.horizontalDivider} />
      <Wrapper>
        <div className={styles.wrapperRow}>
          <Wrapper
            {...wrapperLeftProps}
            padding={sectionPadding}
            className={classnames(styles.widePageWrapperLeft, className)}
          >
            {wrapperLeft}
          </Wrapper>
          <div className={styles.pageDivider} />
          <Wrapper
            {...wrapperRightProps}
            padding={{ ...sectionPadding, left: 'md' }}
            className={classnames(styles.widePageWrapperRight, className)}
            id="widepage-wrapper-right"
          >
            {wrapperRight}
          </Wrapper>
        </div>
      </Wrapper>
    </PageWrapper>
  );
};

const Header: React.FC<Slot> = ({ children }: Slot) => <>{children}</>;
const Left: React.FC<Slot> = ({ children }: Slot) => <>{children}</>;
const Right: React.FC<Slot> = ({ children }: Slot) => <>{children}</>;

WidePageWrapper.Header = Header;
WidePageWrapper.Left = Left;
WidePageWrapper.Right = Right;
